__turbopack_context__.v({
  "arrow": "BlogArticleCard-module__1MwsQa__arrow",
  "body": "BlogArticleCard-module__1MwsQa__body",
  "card": "BlogArticleCard-module__1MwsQa__card",
  "excerpt": "BlogArticleCard-module__1MwsQa__excerpt",
  "header": "BlogArticleCard-module__1MwsQa__header",
  "meta": "BlogArticleCard-module__1MwsQa__meta",
  "metaDot": "BlogArticleCard-module__1MwsQa__metaDot",
  "readMore": "BlogArticleCard-module__1MwsQa__readMore",
  "title": "BlogArticleCard-module__1MwsQa__title",
});
